import { render, staticRenderFns } from "./AddTopping.vue?vue&type=template&id=9e4b3228"
import script from "./AddTopping.vue?vue&type=script&lang=js"
export * from "./AddTopping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports